import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import CardComponent from  './Card/Card.js'
import styles from './Cards.module.css';
//install react spinners by--
/* npm i react-spinners*/
import {BeatLoader} from 'react-spinners'
//install toast by-- /*npm i react-toastify*/
import {ToastContainer,toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { fetchCountries } from '../../api';




const Info = ({ data: { confirmed, recovered, deaths, lastUpdate },country }) => {
  if (!confirmed) {
    return (
      <div>
        <BeatLoader size={55} color='maroon' loading/>  
      </div>
    )
  }
  //console.log(country);

  //create toast 
  /*
  const notify=()=>{
    toast.success('Data came....')
  }
  */

  return (
    <div className={styles.container} >
      <Typography gutterBottom variant="h4" component="h2">{country? `${country}`:'Global'}</Typography>
      <Grid container spacing={3} justify="center">
        <CardComponent
          className={styles.infected}
          cardTitle="Infected"
          value={confirmed.value}
          lastUpdate={lastUpdate}
          cardSubtitle="Number of active cases from COVID-19."
        />
        <CardComponent
          className={styles.recovered}
          cardTitle="Recovered"
          value={recovered.value}
          lastUpdate={lastUpdate}
          cardSubtitle="Number of recoveries from COVID-19."
        />
        <CardComponent
          className={styles.deaths}
          cardTitle="Deaths"
          value={deaths.value}
          lastUpdate={lastUpdate}
          cardSubtitle="Number of deaths due to COVID-19."
        />
      </Grid>
    </div>
  
  );
};

export default Info;